import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ProductListItem} from '../models/product.model';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SearchQueryParams} from '../models/search-query-params.model';
import {getHttpParams} from '../helpers/request.helper';
import {map} from 'rxjs/operators';

@Injectable()
export class ProductService {
    baseUrl = '/api/secured/product';

    constructor(
        private http: HttpClient,
    ) {
    }

    fetchList(props: SearchQueryParams) {
        const {filters, ...searchProps} = props;
        const params = getHttpParams({...searchProps, ...filters, showPartners: true});
        return this.http
            .get<ProductListItem[]>(this.baseUrl, {params, observe: 'response'})
            .pipe(mapSearchListResponse<ProductListItem>(ProductListItem));
    }

    getFieldList(props) {
        return this.http
            .get<ProductListItem[]>(`${this.baseUrl}`, {params: getHttpParams(props), observe: 'response'})
            .pipe(map(response => response.body));
    }

}
